import { type I18nLocale, t } from '@ardoq/i18n';
import { TablesSelectionTexts } from './types';

export const getDefaultTexts = (
  i18nLocale: I18nLocale
): TablesSelectionTexts => ({
  searchLabel: t(
    i18nLocale,
    'integrations:tablesSelection.searchLabel',
    'Select tables'
  ),
  searchText: t(
    i18nLocale,
    'integrations:tablesSelection.searchText',
    'Here is the list of resources available in your integration, select the resources and fields you need.'
  ),
  searchPlaceholder: t(
    i18nLocale,
    'integrations:tablesSelection.searchPlaceholder',
    'Search table name or ID'
  ),
  labelColumnTitle: t(
    i18nLocale,
    'integrations:tablesSelection.labelColumnTitle',
    'Table name'
  ),
  nameColumnTitle: t(
    i18nLocale,
    'integrations:tablesSelection.nameColumnTitle',
    'ID'
  ),
  selectedTitle: t(
    i18nLocale,
    'integrations:tablesSelection.selectedTitle',
    'Tables selected'
  ),
  availableTitle: t(
    i18nLocale,
    'integrations:tablesSelection.availableTitle',
    'Available tables'
  ),
  selectedCount: '',
});
